

























































import Vue from 'vue';
import moment from 'moment';

export default Vue.extend({
  name: 'PicDateTime',
  props: {
    dateInput: {
      type: String,
      required: true
    },
    error: Boolean
  },
  beforeMount(): void {
    this.time = moment(this.dateInput).format('HH:mm');
    this.date = moment(this.dateInput).format('YYYY-MM-DD');
  },
  data() {
    return {
      showDate1: false,
      showDate2: false,
      time: '',
      date: ''
    };
  },
  watch: {
    dateInput(){
      this.time = moment(this.dateInput).format('HH:mm');
      this.date = moment(this.dateInput).format('YYYY-MM-DD');
    }
  },
  methods: {
    save() {
      this.showDate1 = false;
      this.showDate2 = false;
      const formatDateStr = (time: string, date: string, targetDate: string) => moment(date)
        .year(moment(date).year())
        .month(moment(date).month())
        .date(moment(date).date())
        .hour(time.split(':')[0] as any)
        .minute(time.split(':')[1] as any).toISOString();
      const newDate = this.dateInput;

      this.$emit('change', formatDateStr(this.time, this.date, newDate));
    }
  }
});
